import AOS from '../../../../../../../build/node_modules/aos';

document.addEventListener('DOMContentLoaded', () => {
    AOS.init();
});